<template>
    <div class="page">
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button type='primary' size='small' @click='handleAdd'>新增</el-button>
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        :disabled='multipleSelection.length === 0'
                        @click='handleBatchDelete'
                    >批量删除</el-button>
                </div>
                <div class='icon-group'>
                    <!-- <span
                        title='搜索'
                        class='icon-box'
                        @click='toggleSearch'
                    >
                        <Icon color='#606266'>
                            <Search />
                        </Icon>
                    </span> -->
                    <span
                        class='icon-box'
                        title='刷新'
                        @click='refreshActivityList'
                    >
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表 -->
            <el-table
                ref='festivalTable'
                max-height='100%'
                :data='tableData.list'
                row-key='id'
                border
                v-loading='tableLoading'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size='small'
                @selection-change='handleSelectionChange'
            >
                <el-table-column type='selection' width='70' align='center'></el-table-column>
                <el-table-column align='center' prop='festivalName' label='节日名称'></el-table-column>
                <el-table-column align='center' prop='bannerPic' label='节日图片'>
                    <template slot-scope='scope'>
                        <el-image :src='scope.row.bannerPic' style='width: 50px; height: 50px;' :preview-src-list='[scope.row.bannerPic]'></el-image>
                    </template>
                </el-table-column>
                <el-table-column align='center' prop='status' label='状态'>
                    <template slot-scope='scope'>
                        <el-switch v-model='scope.row.status' :active-value="1" :inactive-value="0" active-color="#13ce66" :disabled="scope.row.status === 1" @change='handleStatusChange(scope.row)'></el-switch>
                    </template>
                </el-table-column>
                <el-table-column align='center' prop='createTime' label='创建时间'></el-table-column>
                <el-table-column align='center' prop='updateTime' label='修改时间'></el-table-column>
                <el-table-column align='center' prop='remark' label='备注'></el-table-column>
                <el-table-column align='center' label='操作'>
                    <template slot-scope='scope'>
                        <el-button type='text' size='small' @click='handleEdit(scope.row)'>编辑</el-button>
                        <el-button type='text' size='small' style='color: #f56c6c;' @click='handleDelete(scope.row)'>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { queryForm.pageSize = size; getTableData(); }'
                    @current-change='(page) => { queryForm.pageNum = page; getTableData(); }'
                    :current-page='queryForm.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='queryForm.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    background
                    :total='tableData.total'>
                </el-pagination>
            </div>
        </div>
        <!-- 新增/编辑弹窗 -->
        <el-dialog
            :visible.sync='dialogVisible'
            :title='dialogData.id ? "编辑" : "新增"'
            width='30vw'
            :before-close='handleCloseDialog'
        >
            <div class='detail-dialog-content'>
                <el-form
                    ref='festivalForm'
                    :model='dialogData'
                    :rules='dialogRules'
                    label-width='100px'
                    size='small'
                    style='width: 80%;'
                >
                    <el-form-item label='节日名称' prop='festivalName'>
                        <el-input
                            v-model='dialogData.festivalName'
                            placeholder='请输入节日名称'
                            clearable
                        ></el-input>
                    </el-form-item>
                    <el-form-item label='节日图片' prop='bannerPic'>
                        <el-upload
                            action=''
                            class='avatar-uploader'
                            :show-file-list='false'
                            :http-request='uploadBannerPic'
                        >
                            <img
                                v-if='dialogData.bannerPic'
                                :src='dialogData.bannerPic'
                                class='avatar'
                            />
                            <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label='备注' prop='remark'>
                        <el-input
                            v-model='dialogData.remark'
                            type='textarea'
                            :rows='4'
                            placeholder='请输入备注'
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='handleConfirmDialog'>确定</el-button>
                <el-button @click='handleCloseDialog'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Refresh, Search } from '@v2icons/tabler';
import { post, postJson, get, upload, deleteFun } from '@/utils/request.js';

export default {
    name: 'FestivalActivityManage',
    data() {
        return {
            queryForm: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: {
                list: [],
                total: 0
            },
            tableLoading: false,
            multipleSelection: [],
            dialogVisible: false,
            dialogData: {
                id: '',
                festivalName: '',
                bannerPic: '',
                remark: ''
            },
            dialogRules: {
                festivalName: [{ required: true, message: '请输入节日名称', trigger: 'blur' }],
                bannerPic: [{ required: true, message: '请上传节日图片', trigger: 'change' }]
            }
        }
    },
    components: {
        Refresh,
        Search
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            this.tableLoading = true;
            get(`/shop/festival/findList`, this.queryForm).then((res) => {
                this.tableLoading = false;
                if (res.success) {
                    this.tableData.list = res.page.list;
                    this.tableData.total = res.page.total;
                } else {
                    this.$message.error(res.msg);
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        refreshActivityList() {
            this.queryForm.pageNum = 1;
            this.getTableData();
        },
        getDefaultDialogData() {
            return {
                id: '',
                festivalName: '',
                bannerPic: '',
                remark: ''
            };
        },
        resetDialogData() {
            this.dialogData = this.getDefaultDialogData();
            this.$nextTick(() => {
                if (this.$refs.festivalForm) {
                    this.$refs.festivalForm.resetFields();
                    this.$refs.festivalForm.clearValidate();
                }
            });
        },
        handleCloseDialog() {
            this.dialogVisible = false;
            this.resetDialogData();
        },
        uploadBannerPic(params) {
            const file = params.file;
            const types = ['image/png', 'image/jpg', 'image/jpeg'];
            if (!types.includes(file.type)) {
                this.$message.error('只能上传 png、jpg 或 jpeg 格式的图片');
                return;
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success) {
                    this.$set(this.dialogData, 'bannerPic', res.url);
                    this.$nextTick(() => {
                        this.$refs.festivalForm && this.$refs.festivalForm.validateField('bannerPic');
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleConfirmDialog() {
            this.$refs.festivalForm.validate((valid) => {
                if (!valid) {
                    return;
                }
                const url = this.dialogData.id ? '/shop/festival/edit' : '/shop/festival/add';
                postJson(url, { ...this.dialogData }).then((res) => {
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.handleCloseDialog();
                        this.getTableData();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            });
        },
        handleAdd() {
            this.dialogData = this.getDefaultDialogData();
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.festivalForm) {
                    this.$refs.festivalForm.clearValidate();
                }
            });
        },
        handleEdit(row) {
            this.dialogData = { ...row };
            this.dialogVisible = true;
        },
        handleSelectionChange(selection) {
            this.multipleSelection = selection;
        },
        handleDelete(row) {
            this.confirmAndDelete([row.id]);
        },
        handleBatchDelete() {
            if (this.multipleSelection.length === 0) {
                this.$message.warning('请选择要删除的数据');
                return;
            }
            const ids = this.multipleSelection.map((item) => item.id);
            this.confirmAndDelete(ids);
        },
        confirmAndDelete(ids) {
            this.$confirm('确定删除所选节日吗？', '提示', {
                type: 'warning'
            }).then(() => {
                postJson('/shop/festival/delete', { ids }).then((res) => {
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.multipleSelection = [];
                        if (this.$refs.festivalTable) {
                            this.$refs.festivalTable.clearSelection();
                        }
                        this.getTableData();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }).catch(() => {});
        },
        handleStatusChange(row) {
            postJson('/shop/festival/edit', row).then((res) => {
                if (res.success) {
                    this.$message.success(res.msg);
                    this.getTableData();
                } else {
                    this.$message.error(res.msg);
                    this.getTableData();
                }
            });
        }
    }
}
</script>

<style scoped lang="scss">
.avatar-uploader ::v-deep .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
}

.avatar-uploader ::v-deep .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
}

.avatar {
    width: 100%;
    height: 100%;
    display: block;
}
</style>